export const MissedIcon = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 19.1673C15.0628 19.1673 19.1668 15.0633 19.1668 10.0007C19.1668 4.93804 15.0628 0.833984 10.0002 0.833984C4.93755 0.833984 0.833496 4.93804 0.833496 10.0007C0.833496 15.0633 4.93755 19.1673 10.0002 19.1673Z"
      fill="#999999"
      stroke="#999999"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1665 6.25L6.6665 13.75"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6665 6.25L14.1665 13.75"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
